__turbopack_context__.v({
  "actionIcon": "Yv6qrq_actionIcon",
  "editButton": "Yv6qrq_editButton",
  "member": "Yv6qrq_member",
  "memberBorder": "Yv6qrq_memberBorder",
  "root": "Yv6qrq_root",
  "skills": "Yv6qrq_skills",
});
